import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Button } from '@uhg-abyss/web/ui/Button';

export const NPIValidationsModel = ({ isOpen, closeModal }) => {
  const form = useForm();
  const router = useRouter();
  const handleCloseModal = () => {
    closeModal();
  };

  const handleContinue = () => {
    form.setValue('practiceInformation.isNpiValid', false);
    router.navigate('/tin-registration/step/3');
  };

  return (
    <React.Fragment>
      <Modal
        id="npi-validation-modal"
        title="Unable to Verify NPI"
        isOpen={isOpen}
        onClose={closeModal}
        footer={
          <Modal.Section>
            <Layout.Group alignLayout="right">
              <Button onClick={handleContinue}>Yes</Button>
              <Button variant="outline" onClick={handleCloseModal}>
                No
              </Button>
            </Layout.Group>
          </Modal.Section>
        }
      >
        <Modal.Section>
          NPI(s) entered could not be verified. Please check for errors and try
          again.
          <br />
          <br />
          Do you want to continue?
        </Modal.Section>
      </Modal>
    </React.Fragment>
  );
};

NPIValidationsModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
